import type {
  DialogContentProps,
  DialogProps,
} from '@mui/material';
import Box from '@mui/material/Box';
import DialogContent from '@mui/material/DialogContent';
import type { ReactElement } from 'react';

import { Button } from '../../buttons/Button/index.js';
import { CloseIcon } from '../../icons/CloseIcon/index.js';
import {
  CloseIconButton,
  DialogActions,
  StyledDialog,
  StyledDialogSubTitle,
  StyledDialogTitle,
  TitleWrapper,
} from './FullscreenModal.styled.js';

interface FullscreenModalProps extends DialogProps {
  onClose: VoidFunction;
  onConfirm?: VoidFunction;
  actions?: ReactElement;
  subtitle?: string;
  title?: string;
  dialogContentProps?: DialogContentProps;
}

export const FullscreenModal = ({
  open,
  onClose,
  subtitle,
  title,
  children,
  dialogContentProps,
  onConfirm,
  actions,
  ...props
}: FullscreenModalProps) => {
  return (
    <StyledDialog
      open={open}
      transitionDuration={0}
      fullScreen
      onClose={onClose}
      {...props}
    >
      {title && (
        <TitleWrapper>
          <StyledDialogTitle>{title}</StyledDialogTitle>
          {subtitle && <StyledDialogSubTitle>{subtitle}</StyledDialogSubTitle>}
        </TitleWrapper>
      )}
      <DialogContent {...dialogContentProps}>{children}</DialogContent>
      <CloseIconButton data-testid="close-dialog-button" disableRipple onClick={onClose}>
        <CloseIcon />
      </CloseIconButton>
      {onConfirm && (
        <DialogActions>
          <Box display="flex" justifyContent="flex-end" gap={2} sx={{ maxWidth: theme => theme.breakpoints.values.md }} marginLeft="auto" marginRight="auto" width="100%">
            <Button variant="outlined" onClick={onClose}>
              Back
            </Button>
            <Button variant="contained" onClick={onConfirm}>
              Confirm
            </Button>
          </Box>
        </DialogActions>
      )}
      {actions && <DialogActions>{actions}</DialogActions>}
    </StyledDialog>
  );
};
